/**
 * 害虫知识库 - 静态数据
 * 昆虫清单与防治建议来源：《害虫防治.docx》（标红需入库害虫）
 * 图片来自 Wikimedia Commons / iNaturalist / BOLD / NHM 及国内农业网站（新植保网、黑龙江省农业农村厅、台湾农试所等），若某物种暂无图片则 image 为 null，页面使用图标占位
 */

const imageMap = {
  'chilo-suppressalis': require('@/assets/images/pest-knowledge/chilo-suppressalis.jpg'),
  'nilaparvata-lugens': require('@/assets/images/pest-knowledge/nilaparvata-lugens.jpg'),
  'sogatella-furcifera': require('@/assets/images/pest-knowledge/sogatella-furcifera.jpg'),
  'cnaphalocrocis-medinalis': require('@/assets/images/pest-knowledge/cnaphalocrocis-medinalis.jpg'),
  'lissorhoptrus-oryzophilus': require('@/assets/images/pest-knowledge/lissorhoptrus-oryzophilus.jpg'),
  'spodoptera-frugiperda': require('@/assets/images/pest-knowledge/spodoptera-frugiperda.jpg'),
  'ostrinia-furnacalis': require('@/assets/images/pest-knowledge/ostrinia-furnacalis.jpg'),
  'mythimna-separata': require('@/assets/images/pest-knowledge/mythimna-separata.jpg'),
  'leucania-loreyi': require('@/assets/images/pest-knowledge/leucania-loreyi.jpg'),
  'loxostege-sticticalis': require('@/assets/images/pest-knowledge/loxostege-sticticalis.jpg'),
  'locusta-migratoria': require('@/assets/images/pest-knowledge/locusta-migratoria.jpg'),
  'sitobion-miscanthi': require('@/assets/images/pest-knowledge/sitobion-miscanthi.jpg'),
  'rhopalosiphum-padi': require('@/assets/images/pest-knowledge/rhopalosiphum-padi.jpg'),
  'schizaphis-graminum': require('@/assets/images/pest-knowledge/schizaphis-graminum.jpg'),
  'brevicoryne-brassicae': require('@/assets/images/pest-knowledge/brevicoryne-brassicae.jpg'),
  'myzus-persicae': require('@/assets/images/pest-knowledge/myzus-persicae.jpg'),
  'lipaphis-erysimi': require('@/assets/images/pest-knowledge/lipaphis-erysimi.jpg'),
  'leptinotarsa-decemlineata': require('@/assets/images/pest-knowledge/leptinotarsa-decemlineata.jpg'),
  'cydia-pomonella': require('@/assets/images/pest-knowledge/cydia-pomonella.jpg'),
  'chilo-sacchariphagus': require('@/assets/images/pest-knowledge/chilo-sacchariphagus.jpg'),
  'chilo-infuscatellus': require('@/assets/images/pest-knowledge/chilo-infuscatellus.jpg'),
  'tetramoera-schistaceana': require('@/assets/images/pest-knowledge/tetramoera-schistaceana.jpg'),
  'spodoptera-exigua': require('@/assets/images/pest-knowledge/spodoptera-exigua.jpg'),
  'spodoptera-litura': require('@/assets/images/pest-knowledge/spodoptera-litura.jpg'),
  'sesamia-inferens': require('@/assets/images/pest-knowledge/sesamia-inferens.jpg'),
  'nephotettix-cincticeps': require('@/assets/images/pest-knowledge/nephotettix-cincticeps.jpg'),
  'plutella-xylostella': require('@/assets/images/pest-knowledge/plutella-xylostella.jpg'),
  'conogethes-punctiferalis': require('@/assets/images/pest-knowledge/conogethes-punctiferalis.jpg'),
  'helicoverpa-armigera': require('@/assets/images/pest-knowledge/helicoverpa-armigera.jpg'),
  'laodelphax-striatellus': require('@/assets/images/pest-knowledge/laodelphax-striatellus.jpg'),
  'xestia-c-nigrum': require('@/assets/images/pest-knowledge/xestia-c-nigrum.jpg'),
  'tuta-absoluta': require('@/assets/images/pest-knowledge/tuta-absoluta.jpg'),
  'thrips-palmi': require('@/assets/images/pest-knowledge/thrips-palmi.jpg'),
  'frankliniella-occidentalis': require('@/assets/images/pest-knowledge/frankliniella-occidentalis.jpg'),
  'frankliniella-intonsa': require('@/assets/images/pest-knowledge/frankliniella-intonsa.jpg'),
  'scirpophaga-incertulas': require('@/assets/images/pest-knowledge/scirpophaga-incertulas.jpg'),
  'agrotis-ipsilon': require('@/assets/images/pest-knowledge/agrotis-ipsilon.jpg'),
  'bemisia-tabaci': require('@/assets/images/pest-knowledge/bemisia-tabaci.jpg'),
  'aphis-gossypii': require('@/assets/images/pest-knowledge/aphis-gossypii.jpg'),
  'carposina-sasakii': require('@/assets/images/pest-knowledge/carposina-sasakii.jpg'),
  'grapholita-molesta': require('@/assets/images/pest-knowledge/grapholita-molesta.jpg'),
  'diaphorina-citri': require('@/assets/images/pest-knowledge/diaphorina-citri.jpg'),
  'sitodiplosis-mosellana': require('@/assets/images/pest-knowledge/sitodiplosis-mosellana.jpg'),
  'gryllotalpa-orientalis': require('@/assets/images/pest-knowledge/gryllotalpa-orientalis.jpg'),
  'rhopalosiphum-maidis': require('@/assets/images/pest-knowledge/rhopalosiphum-maidis.jpg'),
  'megalurothrips-usitatus': require('@/assets/images/pest-knowledge/megalurothrips-usitatus.jpg'),
  'leguminivora-glycinivorella': require('@/assets/images/pest-knowledge/leguminivora-glycinivorella.jpg'),
  'holotrichia-oblita': require('@/assets/images/pest-knowledge/holotrichia-oblita.jpg'),
  'fulmekiola-serrata': require('@/assets/images/pest-knowledge/fulmekiola-serrata.jpg'),
  'pleonomus-canaliculatus': require('@/assets/images/pest-knowledge/pleonomus-canaliculatus.jpg')
}

/**
 * 用药提醒（摘自《害虫防治》防治建议）
 * 针对不同螟虫的抗药性现状，必须科学选药、轮换用药，避免盲目加大剂量
 */
export const controlNote =
  '二化螟对氯虫苯甲酰胺的抗性在江西、安徽、浙江等地已达 152~2060 倍，高抗区务必慎用或暂停使用。' +
  '推荐药剂：高抗区首选乙多·甲氧虫、甲维·茚虫威、乙基多杀菌素+喹硫磷/二嗪磷等复配制剂；' +
  '中等发生区可用甲氧虫酰肼、甲维·甲虫肼、阿维·氟铃脲等。' +
  '施药要点：亩用水量要足，重点喷透水稻中下部叶鞘，药后田间保持 3~5 厘米水层 5~7 天。'

export const pestCategories = [

  '水稻害虫',
  '玉米害虫',
  '小麦害虫',
  '大豆害虫',
  '油菜害虫',
  '蔬菜害虫',
  '棉花害虫',
  '马铃薯害虫',
  '果树害虫',
  '甘蔗害虫'
]

export const pestList = [

  {
    id: 1,
    name: '二化螟',
    alias: '钻心虫、蛀心虫',
    scientificName: 'Chilo suppressalis',
    categories: ['水稻害虫', '玉米害虫'],
    level: '一类',
    host: '水稻、茭白、玉米等',
    regions: ['长江流域及以南稻区', '江淮及西南稻区'],
    image: imageMap['chilo-suppressalis'],
    hazard:
      '幼虫钻蛀水稻茎秆：苗期造成枯心苗，分蘖期形成枯鞘，穗期造成白穗和虫伤株，严重时成片枯死倒伏。',
    regular:
      '一年发生 2~4 代，以老熟幼虫在稻桩、稻草内越冬；越冬基数大、单季稻与混栽区发生重，成虫有趋光性。',
    control:
      '冬春翻耕灌水灭蛹压低基数；灯光、性诱剂诱杀成虫；卵孵高峰期科学选药，高抗区慎用氯虫苯甲酰胺（见页面用药提醒），推荐乙多·甲氧虫、甲维·茚虫威等复配制剂，足水喷透稻株中下部，保持浅水层。'
  },

  {
    id: 4,
    name: '稻纵卷叶螟',
    alias: '卷叶虫、刮青虫',
    scientificName: 'Cnaphalocrocis medinalis',
    categories: ['水稻害虫'],
    level: '一类',
    host: '水稻',
    regions: ['长江流域及以南稻区', '江淮稻区'],
    image: imageMap['cnaphalocrocis-medinalis'],
    hazard:
      '幼虫吐丝纵卷叶片，取食叶肉形成白色条斑，严重时全田叶片枯白，影响光合作用，造成秕谷减产。',
    regular:
      '迁飞性害虫，一年发生 4~5 代；偏施氮肥、叶片嫩绿的稻田受害重，成虫有趋光、趋绿性。',
    control:
      '合理施肥促进壮株；释放赤眼蜂、施用 Bt 等生物农药；低龄幼虫期选用甲维盐、氯虫苯甲酰胺防治。'
  },

  {
    id: 2,
    name: '褐飞虱',
    alias: '稻飞虱',
    scientificName: 'Nilaparvata lugens',
    categories: ['水稻害虫'],
    level: '一类',
    host: '水稻',
    regions: ['长江流域及以南稻区', '华南稻区'],
    image: imageMap['nilaparvata-lugens'],
    hazard:
      '成若虫群集稻丛基部刺吸汁液，受害稻株黄叶、矮缩，出现“虱烧”，严重时成团倒伏，还可传播水稻病毒病。',
    regular:
      '迁飞性害虫，夏秋高温多雨、田间荫蔽潮湿时易暴发，7~9 月为发生高峰期。',
    control:
      '浅水勤灌、避免偏施氮肥；保护蜘蛛等天敌；达防治指标时选用吡蚜酮、烯啶虫胺等药剂，对准稻丛基部喷施。'
  },

  {
    id: 3,
    name: '白背飞虱',
    alias: '白背稻虱',
    scientificName: 'Sogatella furcifera',
    categories: ['水稻害虫'],
    level: '一类',
    host: '水稻',
    regions: ['长江中下游稻区', '西南稻区', '华南稻区'],
    image: imageMap['sogatella-furcifera'],
    hazard:
      '成若虫群集稻株中下部刺吸汁液，叶片黄化，影响分蘖和灌浆，并可传播南方水稻黑条矮缩病等病毒病。',
    regular:
      '迁飞性害虫，6~8 月为发生高峰，偏施氮肥、田间荫蔽潮湿的稻田发生较重。',
    control:
      '合理肥水管理，避免贪青旺长；保护天敌；发生初期选用吡蚜酮、噻嗪酮等药剂防治，注意轮换用药。'
  },

  {
    id: 6,
    name: '草地贪夜蛾',
    alias: '秋粘虫',
    scientificName: 'Spodoptera frugiperda',
    categories: ['玉米害虫', '水稻害虫', '甘蔗害虫', '蔬菜害虫'],
    level: '一类',
    host: '玉米、水稻、甘蔗及多种蔬菜',
    regions: ['西南及华南玉米区', '黄淮海夏玉米区', '全国玉米种植区'],
    image: imageMap['spodoptera-frugiperda'],
    hazard:
      '幼虫取食叶片形成孔洞和缺刻，大龄幼虫钻蛀心叶、雄穗和果穗，群体暴发时可造成玉米严重减产。',
    regular:
      '入侵性迁飞害虫，繁殖力强、世代重叠；夏秋季为危害高峰，低龄幼虫有吐丝扩散习性。',
    control:
      '加强灯诱和性诱监测；低龄幼虫期选用甲维盐、氯虫苯甲酰胺、乙基多杀菌素等轮换用药，避免产生抗性。'
  },

  {
    id: 7,
    name: '亚洲玉米螟',
    alias: '玉米钻心虫',
    scientificName: 'Ostrinia furnacalis',
    categories: ['玉米害虫', '棉花害虫'],
    level: '一类',
    host: '玉米、高粱、棉花等',
    regions: ['东北春玉米区', '黄淮海夏玉米区', '西南玉米区'],
    image: imageMap['ostrinia-furnacalis'],
    hazard:
      '幼虫蛀食茎秆、雌雄穗和籽粒，形成蛀孔和虫道，造成茎秆折断、果穗脱落，收获后籽粒受害霉变。',
    regular:
      '一年发生 1~6 代，以老熟幼虫在秸秆、穗轴内越冬；心叶期和抽雄吐丝期为防治关键时期。',
    control:
      '处理秸秆消灭越冬幼虫；心叶末期释放赤眼蜂或撒施 Bt 颗粒剂；大喇叭口期选用氯虫苯甲酰胺等药剂灌心，科学轮换用药。'
  },

  {
    id: 10,
    name: '草地螟',
    alias: '网锥额野螟、黄绿条螟',
    scientificName: 'Loxostege sticticalis',
    categories: ['玉米害虫', '蔬菜害虫'],
    level: '一类',
    host: '大豆、甜菜、向日葵、玉米等多种作物及杂草',
    regions: ['华北、东北农牧交错区', '西北地区'],
    image: imageMap['loxostege-sticticalis'],
    hazard:
      '幼虫吐丝结网群集取食叶片，大发生时可将叶片吃光，是典型的暴发性、迁飞性害虫。',
    regular:
      '一年发生 1~3 代，以老熟幼虫在土中结茧越冬；6~8 月为危害期，成虫趋光，喜在灰菜、苜蓿等杂草上产卵。',
    control:
      '清除田边杂草、中耕灭茧；黑光灯诱杀成虫；低龄幼虫期选用高效氯氰菊酯、甲维盐等药剂防治。'
  },

  {
    id: 8,
    name: '东方粘虫',
    alias: '行军虫、剃枝虫',
    scientificName: 'Mythimna separata',
    categories: ['玉米害虫', '小麦害虫', '水稻害虫'],
    level: '一类',
    host: '玉米、小麦、水稻等禾本科作物',
    regions: ['黄淮海及东北麦玉区', '长江流域'],
    image: imageMap['mythimna-separata'],
    hazard:
      '幼虫群集暴食叶片，严重时吃光叶片并啃食穗部，造成减产甚至绝收；大龄幼虫有假死性和成群迁移习性。',
    regular:
      '迁飞性害虫，一年发生 2~8 代；多雨湿润、田间荫蔽时重发，低龄幼虫白天潜伏、夜间取食。',
    control:
      '糖醋液、黑光灯诱杀成虫；清除田间及田边杂草；3 龄前选用甲维盐、高效氯氰菊酯等药剂防治。'
  },

  {
    id: 9,
    name: '劳氏粘虫',
    alias: '劳氏夜蛾',
    scientificName: 'Leucania loreyi',
    categories: ['玉米害虫', '水稻害虫', '甘蔗害虫'],
    level: '一类',
    host: '玉米、水稻、甘蔗等禾本科作物',
    regions: ['长江流域及以南地区', '华南地区'],
    image: imageMap['leucania-loreyi'],
    hazard:
      '幼虫取食叶片，低龄沿叶脉啃食叶肉，大龄暴食造成缺刻，严重时叶片被吃光，影响光合与灌浆。',
    regular:
      '一年发生多代，秋季危害较重；成虫夜间活动、有趋光性，多雨湿润年份发生偏重。',
    control:
      '参照粘虫综合防治：诱杀成虫、清洁田园消灭虫源，低龄幼虫期药剂防治，注意轮换用药。'
  },

  {
    id: 11,
    name: '飞蝗',
    alias: '蝗虫',
    scientificName: 'Locusta migratoria',
    categories: ['水稻害虫', '小麦害虫', '玉米害虫'],
    level: '一类',
    host: '水稻、小麦、玉米等禾本科作物及杂草',
    regions: ['黄淮海蝗区', '环渤海湾蝗区', '黄河滩区'],
    image: imageMap['locusta-migratoria'],
    hazard:
      '群居型蝗蝻和成虫成群迁飞取食，可迅速吃光大片庄稼，造成毁灭性损失。',
    regular:
      '一年发生 1~2 代，以卵块在土中越冬；夏秋高温干旱、湖滩洼地等适生环境易暴发，有群集迁飞习性。',
    control:
      '改造蝗区生态环境，兴修水利、垦荒种植压缩适生地；推行绿僵菌、微孢子虫等生物防治及牧鸡牧鸭；暴发时选用马拉硫磷等药剂应急防治。'
  },

  {
    id: 12,
    name: '荻草谷网蚜',
    alias: '麦长管蚜',
    scientificName: 'Sitobion miscanthi',
    categories: ['小麦害虫'],
    level: '一类',
    host: '小麦、大麦、燕麦等',
    regions: ['黄淮海麦区', '长江中下游麦区'],
    image: imageMap['sitobion-miscanthi'],
    hazard:
      '成若蚜刺吸叶片、穗部汁液，造成叶片发黄、籽粒秕瘦，分泌蜜露诱发煤污病，并传播小麦黄矮病毒病。',
    regular:
      '一年发生 10~20 代，秋苗期和春季返青拔节期为两个危害高峰；暖冬、干旱年份发生偏重。',
    control:
      '清除田边杂草减少虫源；保护瓢虫、蚜茧蜂等天敌；发生初期选用吡虫啉、啶虫脒或苦参碱等药剂防治。'
  },

  {
    id: 13,
    name: '禾谷缢管蚜',
    alias: '粟缢管蚜',
    scientificName: 'Rhopalosiphum padi',
    categories: ['小麦害虫', '玉米害虫'],
    level: '一类',
    host: '小麦、玉米、高粱等',
    regions: ['黄淮海麦区', '西北及东北麦区'],
    image: imageMap['rhopalosiphum-padi'],
    hazard:
      '多群集叶背、叶鞘和茎部刺吸汁液，造成麦苗黄叶、生长受阻，分泌蜜露诱发煤污病，并传播大麦黄矮病毒。',
    regular:
      '一年发生 10~20 代，以卵或成蚜在禾本科杂草、麦苗上越冬，春季随气温回升迅速繁殖扩散。',
    control:
      '适时播种、合理密植，避免偏施氮肥；保护天敌；苗期、穗期达防治指标时选用吡虫啉等药剂轮换防治。'
  },

  {
    id: 14,
    name: '麦二叉蚜',
    alias: '小麦二叉蚜',
    scientificName: 'Schizaphis graminum',
    categories: ['小麦害虫'],
    level: '一类',
    host: '小麦、大麦、高粱等',
    regions: ['黄淮海及西北旱地麦区'],
    image: imageMap['schizaphis-graminum'],
    hazard:
      '多群集叶片正面和叶鞘刺吸汁液，叶片出现黄褐斑、枯黄，传播病毒病，干旱年份危害较重。',
    regular:
      '一年发生 20 余代，以卵或成蚜在麦苗及杂草上越冬；春季干旱少雨时繁殖迅速、易成灾。',
    control:
      '合理轮作、清除自生麦苗和杂草；保护天敌；发生初期选用吡虫啉、啶虫脒等药剂防治，注意轮换用药。'
  },

  {
    id: 32,
    name: '番茄潜叶蛾',
    alias: '番茄麦蛾、番茄潜麦蛾',
    scientificName: 'Tuta absoluta',
    categories: ['蔬菜害虫'],
    level: '一类',
    host: '番茄、马铃薯、茄子、辣椒等茄科作物',
    regions: ['新疆、云南、四川、贵州等茄科蔬菜产区', '全国设施番茄产区'],
    image: imageMap['tuta-absoluta'],
    hazard:
      '幼虫潜入叶片表皮下取食叶肉，形成白色弯曲潜道，严重时叶片枯黄；还可蛀食嫩茎和果实，果实受害形成孔洞，导致减产和品质下降。',
    regular:
      '一年发生 10~12 代，世代重叠，温暖地区可周年发生；成虫昼伏夜出，卵散产于叶片背面，幼虫有转移为害习性，设施栽培发生重。',
    control:
      '加强检疫防止随种苗传播；悬挂性诱捕器和诱虫板监测诱杀；及时摘除虫叶虫果；药剂选用氯虫苯甲酰胺、乙基多杀菌素、甲维盐等轮换使用，注意喷透叶片正反面。'
  },

  {
    id: 33,
    name: '豆大蓟马',
    alias: '豆花蓟马',
    scientificName: 'Megalurothrips usitatus',
    categories: ['蔬菜害虫'],
    level: '一类',
    host: '豇豆、菜豆、四季豆等豆类蔬菜及花生等',
    regions: ['华南及长江流域豆类蔬菜产区', '西南地区'],
    image: imageMap['megalurothrips-usitatus'],
    hazard:
      '成若虫群集花器锉吸汁液，造成落花落荚、豆荚畸形弯曲，严重影响豆类蔬菜产量和商品性。',
    regular:
      '一年发生多代，世代重叠，温暖干燥气候有利发生；成虫活跃、有趋花性，喜在花内取食产卵，春末至秋季为危害高峰。',
    control:
      '选用抗耐虫品种，覆盖地膜压低虫口；蓝板、性诱剂诱杀；花期重点用药，选用乙基多杀菌素、噻虫嗪、甲维盐等轮换喷雾，注意保护授粉昆虫。'
  },

  {
    id: 34,
    name: '瓜蓟马',
    alias: '棕榈蓟马、节瓜蓟马',
    scientificName: 'Thrips palmi',
    categories: ['蔬菜害虫'],
    level: '一类',
    host: '黄瓜、节瓜、冬瓜、茄子、辣椒等多种蔬菜',
    regions: ['华南、华东及西南瓜菜产区', '长江流域设施菜区'],
    image: imageMap['thrips-palmi'],
    hazard:
      '成若虫锉吸嫩叶、嫩梢和花器汁液，叶片失绿卷曲、出现银白色条斑，嫩梢生长受抑，果实出现“锈皮”和疤痕，降低商品性。',
    regular:
      '一年发生 10 代以上，世代重叠，南方可周年为害；成虫怕光、善飞，喜在嫩叶和花中活动，高温干旱季节和设施内发生重。',
    control:
      '清除田间杂草和残株，覆盖银灰色地膜驱避；蓝板诱杀；发生初期选用乙基多杀菌素、噻虫嗪、多杀菌素等药剂轮换防治，重点喷施嫩叶、花和果蒂部位。'
  },

  {
    id: 35,
    name: '西花蓟马',
    alias: '苜蓿蓟马',
    scientificName: 'Frankliniella occidentalis',
    categories: ['蔬菜害虫'],
    level: '一类',
    host: '辣椒、黄瓜、番茄、草莓及多种花卉和果树',
    regions: ['全国设施蔬菜及花卉产区', '华北、华东及西南露地菜区'],
    image: imageMap['frankliniella-occidentalis'],
    hazard:
      '成若虫锉吸嫩叶、花器和幼果汁液，叶片出现银白色斑点和皱缩，花器受害脱落，果实产生锈斑畸形；还可传播番茄斑萎病毒等多种病毒病。',
    regular:
      '一年发生 10~15 代，世代重叠，温暖干燥环境发生快；成虫趋蓝性、趋黄性强，善飞并易随种苗调运传播，设施栽培周年发生。',
    control:
      '严格种苗检疫，防止随种苗扩散；覆盖防虫网、悬挂蓝板诱杀；选用乙基多杀菌素、噻虫嗪、多杀菌素等药剂轮换防治，注意多种机制交替用药。'
  },

  {
    id: 36,
    name: '花蓟马',
    alias: '台湾花蓟马、花黄蓟马',
    scientificName: 'Frankliniella intonsa',
    categories: ['蔬菜害虫'],
    level: '一类',
    host: '蔬菜、棉花、果树、花卉等多种作物',
    regions: ['长江流域及以南蔬菜、花卉产区', '黄淮海地区'],
    image: imageMap['frankliniella-intonsa'],
    hazard:
      '成若虫群集花器为害，锉吸花器汁液造成落花，果实和嫩叶受害形成锈斑、畸形，影响坐果和商品性。',
    regular:
      '一年发生 6~10 代，以成虫或若虫在杂草、枯枝落叶中越冬；成虫有趋花性和趋光性，春季花期为危害高峰，阴雨潮湿年份发生偏重。',
    control:
      '清洁田园、清除杂草减少虫源；蓝板诱杀；花期选用乙基多杀菌素、噻虫嗪等药剂防治，重点喷施花器和嫩梢，注意轮换用药。'
  },

  {
    id: 25,
    name: '大螟',
    alias: '稻蛀茎夜蛾、紫螟',
    scientificName: 'Sesamia inferens',
    categories: ['水稻害虫', '玉米害虫', '小麦害虫', '甘蔗害虫'],
    level: '二类',
    host: '水稻、玉米、小麦、甘蔗等禾本科作物',
    regions: ['长江中下游稻区', '西南及华南稻区'],
    image: imageMap['sesamia-inferens'],
    hazard:
      '幼虫蛀食稻茎，苗期造成枯心，分蘖期形成枯鞘，穗期造成白穗和虫伤株，蛀孔较大、虫粪明显，常与二化螟混合发生。',
    regular:
      '一年发生 3~7 代，以幼虫在稻桩、杂草和茭白等寄主中越冬；成虫有趋光性，卵多产于叶鞘内侧，幼虫群集为害，发生期一般早于二化螟。',
    control:
      '冬季处理稻桩、铲除田边杂草消灭越冬虫源；灯光诱杀成虫；卵孵高峰期选用氯虫苯甲酰胺、甲维·茚虫威等药剂，对准稻株中下部喷透，并参照页面用药提醒轮换用药。'
  },

  {
    id: 5,
    name: '稻水象甲',
    alias: '稻根象甲',
    scientificName: 'Lissorhoptrus oryzophilus',
    categories: ['水稻害虫'],
    level: '二类',
    host: '水稻及多种禾本科杂草',
    regions: ['西南稻区', '长江中下游稻区', '东北稻区'],
    image: imageMap['lissorhoptrus-oryzophilus'],
    hazard:
      '成虫沿叶脉取食叶肉，叶片出现白色纵条；幼虫危害稻根，根系受损后植株矮化、分蘖减少、易倒伏。',
    regular:
      '一年发生 1~2 代，以成虫在田埂杂草、落叶中越冬；春季迁入秧田为害，幼虫期在根际土中取食。',
    control:
      '严格植物检疫，防止随秧苗、稻草扩散；成虫盛发期选用噻虫嗪、毒死蜱等喷雾，幼虫期结合灌水淹杀。'
  },

  {
    id: 30,
    name: '灰飞虱',
    alias: '灰稻虱',
    scientificName: 'Laodelphax striatellus',
    categories: ['水稻害虫', '小麦害虫', '玉米害虫'],
    level: '二类',
    host: '水稻、小麦、玉米及多种禾本科杂草',
    regions: ['长江中下游稻麦区', '黄淮海稻麦区'],
    image: imageMap['laodelphax-striatellus'],
    hazard:
      '成若虫群集稻株下部刺吸汁液，造成叶片发黄、生长停滞，严重时“虱烧”倒伏；更重要的是传播水稻条纹叶枯病、黑条矮缩病和小麦丛矮病等病毒病。',
    regular:
      '一年发生 5~8 代，以若虫在麦田和杂草上越冬，春季先在小麦上繁殖再迁入稻田；成虫有趋光、趋绿性，喜温暖潮湿环境，5~6 月和 8~9 月为迁入扩散高峰。',
    control:
      '麦收前后及时防虫压低虫源基数，清除田边杂草；保护蜘蛛等天敌；防治重点抓住传毒关键期，选用吡蚜酮、烯啶虫胺、噻嗪酮等药剂对准稻株基部喷施并轮换用药。'
  },

  {
    id: 37,
    name: '三化螟',
    alias: '钻心虫、水稻钻心虫',
    scientificName: 'Scirpophaga incertulas',
    categories: ['水稻害虫'],
    level: '二类',
    host: '水稻（主要为害水稻）',
    regions: ['华南及长江中下游稻区', '西南稻区'],
    image: imageMap['scirpophaga-incertulas'],
    hazard:
      '幼虫蛀食稻茎，苗期造成枯心苗，分蘖期形成枯心群，穗期造成白穗，受害株易倒伏，是华南、西南稻区的重要螟虫。',
    regular:
      '一年发生 2~7 代，以老熟幼虫在稻桩内越冬；成虫有趋光性，卵块产于叶片上并覆有褐色绒毛，幼虫孵化后蛀入稻茎，为害期与水稻生育期吻合。',
    control:
      '冬季灌水灭蛹、处理稻桩压低越冬基数；灯光诱杀成虫；掌握卵孵高峰期选用氯虫苯甲酰胺、甲维·茚虫威等药剂防治，并参照页面螟虫用药提醒轮换用药。'
  },

  {
    id: 49,
    name: '玉米蚜',
    alias: '玉米缢管蚜、麦缢管蚜',
    scientificName: 'Rhopalosiphum maidis',
    categories: ['玉米害虫'],
    level: '二类',
    host: '玉米、高粱、小麦及多种禾本科作物',
    regions: ['黄淮海夏玉米区', '东北春玉米区'],
    image: imageMap['rhopalosiphum-maidis'],
    hazard:
      '成若蚜群集玉米心叶、叶鞘和雄穗刺吸汁液，造成叶片黄化、生长受阻，扬花期雄穗受害影响授粉，分泌蜜露诱发煤污病，还可传播玉米病毒病。',
    regular:
      '一年发生 10~20 代，以成若蚜在禾本科杂草或麦苗上越冬，春季繁殖后迁入玉米田；6~7 月抽雄扬花期种群迅速上升，为危害高峰。',
    control:
      '清除田边杂草，合理密植和施肥；保护瓢虫、草蛉等天敌；发生初期选用吡虫啉、啶虫脒等药剂防治，重点喷施心叶、叶鞘和雄穗。'
  },

  {
    id: 45,
    name: '小麦吸浆虫',
    alias: '麦红吸浆虫、麦蛆',
    scientificName: 'Sitodiplosis mosellana',
    categories: ['小麦害虫'],
    level: '二类',
    host: '小麦（也可为害大麦、燕麦）',
    regions: ['黄淮海麦区', '陕西、甘肃、四川等麦区'],
    image: imageMap['sitodiplosis-mosellana'],
    hazard:
      '幼虫潜伏在麦穗颖壳内吸食正在灌浆的麦粒汁液，造成秕粒、空壳，严重时减产 30%~50%，是小麦的重要毁灭性害虫。',
    regular:
      '一年发生 1 代，以老熟幼虫在土中结茧越夏越冬；春季化蛹羽化，成虫在麦穗上产卵，幼虫孵化后钻入颖壳为害，4~5 月为危害期。',
    control:
      '选用抗虫品种，轮作倒茬；土壤处理压低虫源，成虫期撒施毒土；药剂防治抓住成虫羽化和幼虫孵化关键期，可选用高效氯氰菊酯等喷雾或毒土处理。'
  },

  {
    id: 46,
    name: '沟金针虫',
    alias: '叩头虫、铁丝虫、沟叩头甲',
    scientificName: 'Pleonomus canaliculatus',
    categories: ['小麦害虫', '玉米害虫'],
    level: '二类',
    host: '小麦、玉米、马铃薯、花生等多种作物',
    regions: ['黄淮海及西北旱作区', '东北地区'],
    image: imageMap['pleonomus-canaliculatus'],
    hazard:
      '幼虫在地下咬食种子、幼根和茎基部，造成缺苗断垄，植株萎蔫枯死；为害块茎和块根时形成孔道，降低产量和品质。',
    regular:
      '约 3 年完成 1 代，以成虫和幼虫在土中越冬；春季地温回升后幼虫上移为害，秋播和春播期出现两个危害高峰，土壤干旱的沙壤地受害重。',
    control:
      '深耕翻晒和轮作压低虫源；播种前药剂拌种或土壤处理；发生期用辛硫磷等药剂灌根或撒施毒土，注意保护天敌和用药安全。'
  },

  {
    id: 43,
    name: '大豆食心虫',
    alias: '大豆蛀荚虫、豆荚虫',
    scientificName: 'Leguminivora glycinivorella',
    categories: ['大豆害虫'],
    level: '二类',
    host: '大豆、野生大豆等',
    regions: ['东北大豆产区', '黄淮海大豆产区'],
    image: imageMap['leguminivora-glycinivorella'],
    hazard:
      '幼虫蛀入豆荚取食豆粒，形成蛀孔和虫道，豆粒残缺或虫粪污染，严重影响大豆产量和品质，是东北大豆产区主要害虫。',
    regular:
      '一年发生 1 代，以老熟幼虫在土中结茧越冬；成虫有趋光性，产卵于豆荚上，幼虫孵化后蛀荚为害，8 月为危害盛期。',
    control:
      '轮作倒茬，秋翻地破坏越冬茧；成虫期灯光诱杀或释放赤眼蜂；卵孵高峰期选用氯虫苯甲酰胺、甲维盐等药剂防治，收获后及时清理豆田。'
  },

  {
    id: 15,
    name: '甘蓝蚜',
    alias: '菜蚜、白菜蚜',
    scientificName: 'Brevicoryne brassicae',
    categories: ['油菜害虫', '蔬菜害虫'],
    level: '二类',
    host: '甘蓝、花椰菜、白菜等十字花科蔬菜及油菜',
    regions: ['华北及长江流域菜区', '西南菜区'],
    image: imageMap['brevicoryne-brassicae'],
    hazard:
      '成若蚜群集叶背、嫩茎和花梗刺吸汁液，叶片卷缩变黄，花梗扭曲，传播病毒病，蜜露引发煤污病。',
    regular:
      '一年发生 10~20 代，以卵在十字花科蔬菜上越冬；春秋两季为发生高峰，温暖干燥时繁殖快。',
    control:
      '合理布局、避免连作；黄板诱杀、银灰膜避蚜；保护天敌，发生期选用吡虫啉、氟啶虫胺腈等轮换用药。'
  },

  {
    id: 16,
    name: '桃蚜',
    alias: '烟蚜、腻虫',
    scientificName: 'Myzus persicae',
    categories: ['蔬菜害虫', '油菜害虫', '果树害虫'],
    level: '二类',
    host: '桃、李、烟草、油菜及多种蔬菜',
    regions: ['全国各菜区、烟区及桃园'],
    image: imageMap['myzus-persicae'],
    hazard:
      '群集嫩叶、嫩梢和花蕾刺吸汁液，造成叶片卷缩、生长停滞，并传播黄瓜花叶病毒等多种病毒病。',
    regular:
      '一年发生 10~30 代，以卵或成蚜在寄主上越冬；春秋两季为发生高峰，干旱年份危害加重。',
    control:
      '保护和利用瓢虫、食蚜蝇等天敌；黄板诱杀有翅蚜；药剂选用吡虫啉、氟啶虫胺腈等，注意轮换用药。'
  },

  {
    id: 17,
    name: '萝卜蚜',
    alias: '菜缢管蚜',
    scientificName: 'Lipaphis erysimi',
    categories: ['蔬菜害虫', '油菜害虫'],
    level: '二类',
    host: '萝卜、白菜、油菜等十字花科作物',
    regions: ['长江流域及华南菜区', '西南菜区'],
    image: imageMap['lipaphis-erysimi'],
    hazard:
      '成若蚜群集嫩叶、嫩茎和角果刺吸汁液，叶片黄化卷缩、植株矮小，传播病毒病，影响开花结实。',
    regular:
      '一年发生 10~30 代，以无翅胎生雌蚜在十字花科蔬菜上越冬；春秋两季发生重，偏施氮肥田块受害重。',
    control:
      '清洁田园、清除杂草；黄板诱杀；低龄若蚜期用药防治，注意保护天敌并轮换用药。'
  },

  {
    id: 23,
    name: '甜菜夜蛾',
    alias: '贪夜蛾、玉米小夜蛾',
    scientificName: 'Spodoptera exigua',
    categories: ['蔬菜害虫', '棉花害虫', '玉米害虫'],
    level: '二类',
    host: '甜菜、棉花、大豆、玉米、花生及多种蔬菜',
    regions: ['长江流域及华南菜区', '黄淮海菜区', '棉花产区'],
    image: imageMap['spodoptera-exigua'],
    hazard:
      '初孵幼虫群集叶背取食叶肉，留下透明表皮；大龄幼虫分散暴食叶片，形成孔洞缺刻，严重时吃光叶片，还可蛀食花蕾、果实，是典型的暴发性害虫。',
    regular:
      '一年发生 4~8 代，以蛹在土中越冬；世代重叠严重，成虫有趋光性和趋化性，卵块产于叶片背面，夏秋高温干旱年份易暴发为害。',
    control:
      '清除田间杂草和残株、深耕灭蛹；黑光灯和性诱剂诱杀成虫，结合人工摘除卵块；低龄幼虫期选用甲维盐、氯虫苯甲酰胺、乙基多杀菌素等轮换用药，注意保护天敌。'
  },

  {
    id: 24,
    name: '斜纹夜蛾',
    alias: '莲纹夜蛾',
    scientificName: 'Spodoptera litura',
    categories: ['蔬菜害虫', '棉花害虫'],
    level: '二类',
    host: '棉花、烟草、甘薯、花生及多种蔬菜',
    regions: ['长江流域及以南菜区', '华南地区'],
    image: imageMap['spodoptera-litura'],
    hazard:
      '低龄幼虫群集取食叶肉，3 龄后分散暴食，可将叶片吃光仅剩叶脉，还可钻蛀花蕾和果实，暴发时造成毁灭性损失。',
    regular:
      '一年发生 4~8 代，以蛹在土中越冬；成虫夜间活动、有趋光性，卵块产于叶片背面并覆盖鳞毛；夏秋高温、田间荫蔽时发生重，世代重叠明显。',
    control:
      '清除杂草落叶、翻耕灭蛹；黑光灯和性诱剂诱杀成虫，摘除卵块和群集幼虫；低龄期选用甲维盐、茚虫威、氯虫苯甲酰胺等药剂轮换喷雾，注意喷匀叶片正反面。'
  },

  {
    id: 27,
    name: '小菜蛾',
    alias: '吊丝虫、小青虫、两头尖',
    scientificName: 'Plutella xylostella',
    categories: ['蔬菜害虫', '油菜害虫'],
    level: '二类',
    host: '甘蓝、花椰菜、白菜、萝卜等十字花科蔬菜',
    regions: ['长江流域及以南菜区', '华南、西南菜区'],
    image: imageMap['plutella-xylostella'],
    hazard:
      '低龄幼虫潜叶或啃食叶肉留下透明表皮，3 龄后取食叶片形成孔洞缺刻，严重时叶片被吃成网状，还可危害嫩茎和种荚，影响商品性和产量。',
    regular:
      '一年发生 6~20 代，世代重叠，以蛹在残株落叶上越冬；成虫昼伏夜出、有趋光性，春秋两季为发生高峰，冬季温暖地区可周年发生。',
    control:
      '避免十字花科蔬菜连作，收获后清洁田园；性诱剂、黑光灯诱杀成虫；优先选用 Bt、阿维菌素、氯虫苯甲酰胺等药剂轮换防治，延缓抗性产生。'
  },

  {
    id: 31,
    name: '八字地老虎',
    alias: '八字切根虫',
    scientificName: 'Xestia c-nigrum',
    categories: ['蔬菜害虫', '玉米害虫', '棉花害虫'],
    level: '二类',
    host: '蔬菜幼苗、烟草、玉米、棉花及多种作物和杂草',
    regions: ['华北、东北及西南旱作区', '长江流域'],
    image: imageMap['xestia-c-nigrum'],
    hazard:
      '幼虫咬断作物幼苗近地面茎部，造成缺苗断垄；也可取食叶片和嫩茎，低龄幼虫食叶成孔洞，大龄幼虫白天潜伏土中、夜间出土为害。',
    regular:
      '一年发生 2~3 代，以幼虫或蛹在土中越冬；成虫趋光、趋化性强，喜在杂草和作物叶片上产卵；春秋两季为危害高峰，田间杂草多、土壤疏松的地块受害重。',
    control:
      '清除田间及田边杂草，秋翻冬灌消灭越冬虫源；糖醋液、黑光灯诱杀成虫；幼虫期结合中耕人工捕杀，或选用辛硫磷等药剂撒施、灌根，注意轮换用药。'
  },

  {
    id: 38,
    name: '小地老虎',
    alias: '土蚕、地蚕、切根虫',
    scientificName: 'Agrotis ipsilon',
    categories: ['蔬菜害虫', '玉米害虫'],
    level: '二类',
    host: '蔬菜幼苗、玉米、棉花、烟草及多种旱地作物',
    regions: ['全国各旱作区', '长江流域及西南蔬菜产区'],
    image: imageMap['agrotis-ipsilon'],
    hazard:
      '幼虫咬断作物幼苗近地面茎部，造成缺苗断垄；3 龄前群集取食叶片，3 龄后分散转入土中，夜间出土咬断幼苗，危害期短但损失大。',
    regular:
      '一年发生 2~7 代，以幼虫或蛹在土中越冬；成虫有趋光性和趋化性，喜在杂草和作物叶片上产卵；春季为危害高峰，土壤湿润、杂草多的田块受害重。',
    control:
      '清除田间及田边杂草，秋翻冬灌消灭越冬虫源；糖醋液、黑光灯诱杀成虫；幼虫期结合中耕人工捕杀或毒饵诱杀，药剂可选用辛硫磷等灌根或撒施。'
  },

  {
    id: 39,
    name: '烟粉虱',
    alias: '白粉虱、银叶粉虱',
    scientificName: 'Bemisia tabaci',
    categories: ['蔬菜害虫', '棉花害虫'],
    level: '二类',
    host: '番茄、辣椒、黄瓜等蔬菜及棉花、烟草等多种作物',
    regions: ['华北、华东设施蔬菜产区', '新疆棉区', '华南及长江流域'],
    image: imageMap['bemisia-tabaci'],
    hazard:
      '成若虫群集叶背刺吸汁液，造成叶片黄化、卷曲和煤污病；还可传播多种双生病毒病（如番茄黄化曲叶病毒病），传毒危害常重于直接刺吸。',
    regular:
      '一年发生 10 代以上，世代重叠，保护地内可周年繁殖；成虫趋黄性、趋嫩性，高温干旱季节和设施栽培条件下发生重，易随种苗调运扩散。',
    control:
      '培育无虫苗，覆盖防虫网；黄板诱杀；保护丽蚜小蜂等天敌；发生期选用吡虫啉、噻虫嗪、螺虫乙酯等药剂轮换防治，注意叶片正反面喷匀。'
  },

  {
    id: 47,
    name: '华北大黑鳃金龟',
    alias: '大黑鳃金龟（蛴螬）',
    scientificName: 'Holotrichia oblita',
    categories: ['蔬菜害虫', '玉米害虫'],
    level: '二类',
    host: '花生、大豆、玉米、蔬菜及果树等多种作物',
    regions: ['华北、黄淮海及西北旱作区'],
    image: imageMap['holotrichia-oblita'],
    hazard:
      '幼虫（蛴螬）在地下咬食根系和块根块茎，造成植株枯死、缺苗断垄；成虫取食果树和林木叶片，造成叶片缺刻，是重要地下害虫。',
    regular:
      '约 2 年完成 1 代，以成虫或幼虫在土中越冬；成虫有趋光性和假死性，6~8 月为成虫盛发期，幼虫春秋两季在耕作层为害。',
    control:
      '黑光灯诱杀成虫，结合人工捕杀；深耕和轮作压低虫源；播种期药剂拌种或土壤处理，生长期用辛硫磷等药剂灌根防治蛴螬。'
  },

  {
    id: 48,
    name: '东方蝼蛄',
    alias: '拉拉蛄、土狗子',
    scientificName: 'Gryllotalpa orientalis',
    categories: ['蔬菜害虫', '小麦害虫', '玉米害虫'],
    level: '二类',
    host: '蔬菜、小麦、玉米、水稻秧田等多种作物',
    regions: ['全国各旱作区', '长江流域及以北地区'],
    image: imageMap['gryllotalpa-orientalis'],
    hazard:
      '成若虫在土中挖掘隧道，咬食种子、幼苗根系和茎基部，造成幼苗干枯死亡，苗床和秧田受害重，隧道还易使幼苗失水倒伏。',
    regular:
      '1~2 年完成 1 代，以成若虫在土中越冬；有趋光性、趋粪性和趋湿性，春秋两季在表土层活动为害，夜间出土活动，土壤湿润处发生重。',
    control:
      '施用充分腐熟的粪肥，避免诱虫；灯光诱杀成虫，毒饵诱杀；苗床期药剂拌种或撒施毒土，保护天敌和鸟类。'
  },

  {
    id: 29,
    name: '棉铃虫',
    alias: '棉铃实夜蛾、钻桃虫',
    scientificName: 'Helicoverpa armigera',
    categories: ['棉花害虫', '蔬菜害虫', '玉米害虫'],
    level: '二类',
    host: '棉花、番茄、辣椒、玉米、大豆、花生等多种作物',
    regions: ['黄河流域棉区', '长江流域棉区', '新疆棉区'],
    image: imageMap['helicoverpa-armigera'],
    hazard:
      '幼虫蛀食棉蕾、花和铃，造成蕾铃脱落、烂铃；也取食番茄果实和玉米果穗，钻蛀取食并留下虫粪，严重影响产量和品质。',
    regular:
      '一年发生 3~6 代，以蛹在土中越冬；成虫有趋光性和趋化性，卵散产于嫩叶和蕾铃上，幼虫有转株为害习性，7~8 月为危害高峰。',
    control:
      '冬季深耕灌水灭蛹，合理轮作；利用黑光灯、性诱剂和杨树枝把诱杀成虫，保护赤眼蜂等天敌；卵孵高峰期选用氯虫苯甲酰胺、甲维盐、茚虫威等药剂轮换防治。'
  },

  {
    id: 40,
    name: '棉蚜',
    alias: '腻虫、瓜蚜',
    scientificName: 'Aphis gossypii',
    categories: ['棉花害虫', '蔬菜害虫'],
    level: '二类',
    host: '棉花、瓜类及多种蔬菜和果树',
    regions: ['黄河流域棉区', '新疆棉区', '全国瓜类产区'],
    image: imageMap['aphis-gossypii'],
    hazard:
      '成若蚜群集嫩叶、嫩茎和花蕾刺吸汁液，造成叶片卷缩、生长停滞，分泌蜜露诱发煤污病；还可传播黄瓜花叶病毒等多种病毒病。',
    regular:
      '一年发生 20~30 代，以卵在木槿、花椒等寄主上越冬；有翅蚜迁飞扩散能力强，春秋两季为发生高峰，干旱年份发生重。',
    control:
      '保护瓢虫、草蛉、蚜茧蜂等天敌；黄板诱杀有翅蚜；药剂选用吡虫啉、啶虫脒、氟啶虫胺腈等轮换使用，注意棉田花期保护授粉昆虫。'
  },

  {
    id: 28,
    name: '桃蛀螟',
    alias: '桃蠹螟、桃蛀野螟',
    scientificName: 'Conogethes punctiferalis',
    categories: ['果树害虫', '玉米害虫'],
    level: '二类',
    host: '桃、梨、苹果、李、板栗、向日葵、玉米等',
    regions: ['黄淮海及华北果区', '西南果区', '玉米产区'],
    image: imageMap['conogethes-punctiferalis'],
    hazard:
      '幼虫蛀食果实，蛀孔外堆积虫粪，果内充满虫粪易腐烂脱落；还可蛀食玉米穗和向日葵花盘等，是多种果树和旱地作物的重要蛀食性害虫。',
    regular:
      '一年发生 2~5 代，以老熟幼虫在树皮裂缝、向日葵秆、玉米秸秆等处越冬；成虫昼伏夜出、有趋光性，喜在果萼和叶背产卵，世代重叠。',
    control:
      '冬季刮除老翘皮，处理玉米秸秆和向日葵秆消灭越冬幼虫；及时摘除虫果并深埋；黑光灯、糖醋液诱杀成虫；卵孵期选用氯虫苯甲酰胺、甲维盐等药剂防治。'
  },

  {
    id: 41,
    name: '桃小食心虫',
    alias: '桃蛀果蛾、桃小',
    scientificName: 'Carposina sasakii',
    categories: ['果树害虫'],
    level: '二类',
    host: '苹果、枣、桃、山楂、梨等',
    regions: ['黄淮海及东北果区', '西北果区'],
    image: imageMap['carposina-sasakii'],
    hazard:
      '幼虫蛀入果实，在果内串食并排泄粪便，形成“豆沙馅”状被害果，果实早落或失去商品价值，是北方果区最重要的蛀果害虫之一。',
    regular:
      '一年发生 1~2 代，以老熟幼虫在树冠下土中结茧越冬；成虫昼伏夜出，卵多产于果萼洼处，幼虫孵化后蛀果为害，6~8 月为危害期。',
    control:
      '树下地面覆盖或培土压茧，幼虫脱果期地面用药；性诱剂监测和诱杀；卵孵高峰期选用氯虫苯甲酰胺、甲维盐等药剂防治，及时捡拾处理虫果。'
  },

  {
    id: 42,
    name: '梨小食心虫',
    alias: '东方果蛀蛾、梨小',
    scientificName: 'Grapholita molesta',
    categories: ['果树害虫'],
    level: '二类',
    host: '梨、桃、苹果、李、杏等',
    regions: ['华北、西北及长江流域果区', '东北果区'],
    image: imageMap['grapholita-molesta'],
    hazard:
      '幼虫蛀食新梢和果实，桃李上新梢受害后萎蔫折断，梨果受害后蛀道内充满虫粪，果实腐烂脱落，严重影响产量和商品性。',
    regular:
      '一年发生 3~7 代，以老熟幼虫在树皮裂缝和树干基部结茧越冬；成虫有趋光性和趋化性，喜食糖醋液，世代重叠明显。',
    control:
      '刮除老翘皮消灭越冬幼虫；悬挂性诱捕器监测诱杀；及时剪除受害新梢、捡拾虫果；药剂选用氯虫苯甲酰胺、甲维盐等，注意轮换用药。'
  },

  {
    id: 44,
    name: '柑橘木虱',
    alias: '柑橘叶虱',
    scientificName: 'Diaphorina citri',
    categories: ['果树害虫'],
    level: '二类',
    host: '柑橘类果树（黄龙病传播媒介）',
    regions: ['华南柑橘产区', '江西、湖南、四川、云南柑橘产区'],
    image: imageMap['diaphorina-citri'],
    hazard:
      '成若虫群集嫩梢刺吸汁液，造成嫩梢萎缩、畸形，排泄蜜露诱发煤污病；更重要的是传播柑橘黄龙病，是黄龙病最主要的传播媒介。',
    regular:
      '一年发生 8~14 代，世代重叠，在柑橘嫩梢期出现两个高峰；成虫趋黄性，喜在嫩芽上取食产卵，冬季温暖地区可周年繁殖。',
    control:
      '加强苗木检疫，使用无病苗木；抹除零星嫩梢、统一放梢，黄板诱杀；保护跳小蜂等天敌；嫩梢期选用噻虫嗪、吡虫啉等药剂防治，并配合清除黄龙病病株。'
  },

  {
    id: 20,
    name: '甘蔗条螟',
    alias: '甘蔗钻心虫、条螟',
    scientificName: 'Chilo sacchariphagus',
    categories: ['甘蔗害虫'],
    level: '二类',
    host: '甘蔗',
    regions: ['华南蔗区', '云南蔗区'],
    image: imageMap['chilo-sacchariphagus'],
    hazard:
      '幼虫蛀入蔗茎为害，形成蛀孔和虫道，苗期造成枯心，成株期形成螟害节，易诱发赤腐病，降低糖分。',
    regular:
      '一年发生 4~5 代，以老熟幼虫在蔗茎、枯叶中越冬；5~11 月为发生期，成虫有趋光性。',
    control:
      '选用抗虫品种，及时销毁蔗头、蔗渣；释放赤眼蜂等天敌；卵孵高峰期科学选药，参照螟虫抗性治理原则轮换用药。'
  },

  {
    id: 21,
    name: '甘蔗二点螟',
    alias: '二点螟',
    scientificName: 'Chilo infuscatellus',
    categories: ['甘蔗害虫', '玉米害虫'],
    level: '二类',
    host: '甘蔗、玉米、高粱等',
    regions: ['华南蔗区', '云南蔗区'],
    image: imageMap['chilo-infuscatellus'],
    hazard:
      '幼虫蛀食蔗苗基部造成枯心苗，后期蛀茎形成螟害节，易风折，降低产量和糖分。',
    regular:
      '一年发生 4~5 代，以老熟幼虫在蔗蔸、枯叶中越冬；春旱年份危害重，成虫有趋光性。',
    control:
      '清洁田园、消灭越冬虫源；利用赤眼蜂、白僵菌等生物防治；化学防治参照螟虫用药提醒，科学轮换用药。'
  },

  {
    id: 22,
    name: '甘蔗黄螟',
    alias: '黄螟',
    scientificName: 'Tetramoera schistaceana',
    categories: ['甘蔗害虫'],
    level: '二类',
    host: '甘蔗',
    regions: ['华南蔗区', '云南蔗区'],
    image: imageMap['tetramoera-schistaceana'],
    hazard:
      '幼虫蛀入蔗茎为害，苗期造成枯心，生长期蛀食蔗茎基部，虫道纵横，易倒伏并诱发赤腐病。',
    regular:
      '一年发生 5~6 代，世代重叠，以幼虫或蛹在蔗茎、蔗蔸中越冬；温暖多雨季节发生较重。',
    control:
      '选用抗虫良种、清除蔗蔸；保护赤眼蜂等天敌；药剂防治参照螟虫防治原则，科学轮换用药。'
  },

  {
    id: 50,
    name: '蔗腹齿蓟马',
    alias: '甘蔗蓟马',
    scientificName: 'Fulmekiola serrata',
    categories: ['甘蔗害虫'],
    level: '二类',
    host: '甘蔗',
    regions: ['广西、云南、广东等华南蔗区'],
    image: imageMap['fulmekiola-serrata'],
    hazard:
      '成若虫群集甘蔗心叶和叶鞘内侧锉吸汁液，受害心叶出现黄褐色斑纹、卷曲干枯，生长受阻，蔗茎变细、产量下降。',
    regular:
      '一年发生多代，世代重叠，以成若虫在蔗株上或枯叶中越冬；温暖干旱季节发生重，宿根蔗和长势弱的蔗田受害明显，7~9 月为危害高峰。',
    control:
      '选用抗虫品种，加强水肥管理促进生长；及时剥除老叶、清除枯叶；发生期选用吡虫啉、噻虫嗪、乙基多杀菌素等药剂防治，注意喷施心叶部位。'
  },

  {
    id: 26,
    name: '黑尾叶蝉',
    alias: '稻叶蝉、黑尾浮尘子',
    scientificName: 'Nephotettix cincticeps',
    categories: ['水稻害虫'],
    level: '其他',
    host: '水稻及多种禾本科杂草',
    regions: ['长江中下游及以南稻区'],
    image: imageMap['nephotettix-cincticeps'],
    hazard:
      '成若虫群集稻株茎基部和叶片刺吸汁液，叶片出现褐色条斑、变黄枯死；还可传播水稻矮缩病、黄矮病等病毒病，传毒危害重于直接刺吸。',
    regular:
      '一年发生 4~8 代，以成虫和若虫在杂草、稻桩上越冬；成虫有趋光性和趋绿性，6~8 月为发生高峰，偏施氮肥、长势嫩绿的稻田受害重。',
    control:
      '清除田边杂草、合理施肥避免贪青；保护蜘蛛和寄生蜂等天敌；成虫迁入期和若虫高峰期选用吡虫啉、噻嗪酮、烯啶虫胺等药剂防治，注意轮换用药。'
  },

  {
    id: 18,
    name: '马铃薯甲虫',
    alias: '蔬菜花斑虫',
    scientificName: 'Leptinotarsa decemlineata',
    categories: ['马铃薯害虫', '蔬菜害虫'],
    level: '其他',
    host: '马铃薯、茄子、番茄等茄科作物',
    regions: ['新疆及周边地区', '东北局部'],
    image: imageMap['leptinotarsa-decemlineata'],
    hazard:
      '成虫和幼虫取食叶片，严重时仅剩叶脉和茎秆，造成减产甚至绝收，是国际检疫性害虫。',
    regular:
      '一年发生 1~3 代，以成虫在土中越冬；春季出土取食产卵，6~8 月幼虫危害高峰，有假死性。',
    control:
      '加强植物检疫；轮作倒茬、及时清除残株；保护利用蠋蝽、草蛉等天敌；幼虫期选用氯虫苯甲酰胺、阿维菌素等轮换用药。'
  },

  {
    id: 19,
    name: '苹果蠹蛾',
    alias: '苹果小卷蛾',
    scientificName: 'Cydia pomonella',
    categories: ['果树害虫'],
    level: '其他',
    host: '苹果、梨、桃、杏等',
    regions: ['新疆、甘肃、宁夏及内蒙古西部'],
    image: imageMap['cydia-pomonella'],
    hazard:
      '幼虫蛀食果实，蛀孔周围留有虫粪，果实提前脱落，是国际检疫性害虫，对果品产量和商品性影响极大。',
    regular:
      '一年发生 1~3 代，以老熟幼虫在树皮裂缝、树干基部结茧越冬；成虫有趋光性和趋化性。',
    control:
      '刮除老翘皮消灭越冬幼虫；悬挂性诱捕器监测和诱杀；落果期及时捡拾处理虫果，药剂选用氯虫苯甲酰胺等。'
  }
]
